module.exports = __webpack_public_path__ + "static/media/SELECTstage4.5387f6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/SELECTstage4.png
// module id = 170
// module chunks = 0